export const APPLICATION_STEPS = [
  "Campaign scope",
  "Business",
  "Website",
  "Campaign",
  "Opt-in method",
  "Consent wording",
  "Sample messages",
  "Evidence",
  "Review",
] as const;
export const MESSAGE_CATEGORIES = [
  "Marketing",
  "Appointment Reminders",
  "Customer Care",
  "Account Notifications",
  "Application Updates",
  "Transactional",
  "Other",
] as const;
export const OPT_IN_METHODS = [
  "Website Form",
  "Landing Page",
  "Calendar / Booking Page",
  "Keyword",
  "QR Code",
  "Paper Form",
  "Verbal Consent",
  "Other",
] as const;
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ALLOWED_UPLOADS = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "application/pdf",
] as const;
export const EVIDENCE_TYPES = [
  "Desktop Opt-In Form",
  "Mobile Opt-In Form",
  "Consent Checkbox",
  "Website Footer",
  "Privacy Policy",
  "Terms",
  "Other Supporting Evidence",
] as const;
export const DISCLAIMER =
  "This assessment is an independent preparation and risk-review tool. Passing the assessment does not guarantee A2P approval. Final approval decisions are made by the applicable registration providers, carriers, The Campaign Registry, and other reviewers.";
